<template>
  <div class="app flex-row align-items-center bg-gradient">
    <spinner/>
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="7">
          <b-card-group>
            <b-card no-body class="p-5">
              <b-card-body>
                <b-row>
                    <b-col md="12" class="text-center mb-4">
                      <img src="img/logo.png" width="120" class="mb-2">
                      <h4>SIPP Limbah B3</h4>
                    </b-col>
                    <ResponseAlert ref="response" />
                </b-row>
                <form @submit.prevent="login" class="needs-validation" novalidate>
                  <div class="form-group" :class="{'has-error': errors.has('email') }">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <div class="input-group-text"><i class="icon-envelope"></i></div>
                      </div>
                      <input v-model="models.email" 
                              v-validate="'required'" 
                              name="email" 
                              class="form-control" 
                              type="text" 
                              placeholder="Email">
                    </div>
                    <div class="help-block" v-if="errors.has('email')">
                      <p class="text-danger">{{ errors.first('email') }}</p>
                    </div>
                  </div>
                  <div class="form-group" :class="{'has-error': errors.has('password') }">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <div class="input-group-text"><i class="icon-lock"></i></div>
                      </div>
                      <input v-model="models.password" 
                              v-validate="'required'" 
                              name="password" 
                              class="form-control" 
                              :type="password_show ? 'text' : 'password'"
                              placeholder="Password">
                      <div class="input-group-prepend">
                        <span class="input-group-text cursor-pointer" @click="password_show = password_show ? false : true">
                          <i :class=" password_show ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                        </span>
                      </div>
                    </div>
                    <div class="help-block" v-if="errors.has('password')">
                      <p class="text-danger">{{ errors.first('password') }}</p>
                    </div>
                  </div>
                  <b-row>
                    <b-col cols="12">
                      <b-button type="submit" variant="primary" class="px-4 btn-block">Login</b-button>
                      <a href="#/home" class="btn btn-block">Kembali ke Beranda</a>
                    </b-col>
                  </b-row>
                </form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style scoped>
.bg-gradient{
  background: rgb(25 123 48);
}
</style>
<script>
import Spinner from "@/components/spinner";
import ResponseAlert from '@/components/response_alert';
export default {
  name: 'Login',
  components: {
    Spinner,
    ResponseAlert,
  },
  data() {
    return {
      models : {},
			password_show: false,
    }
  },
  methods : {
    login(){
      const _ = this;
      _.$validator.validate().then(valid => {
        if (valid) {
          _.$axios.post('/Authentication/login',_.models)
          .then(resp => _.$store.dispatch('login',resp.data.data))
          .catch(error => _.$refs.response.setResponse(error.response.data.message, 'danger'));
        }
      });
    }
  }
}
</script>